var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgColumns = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.414,
    height: 20.414,
    viewBox: "0 0 20.414 20.414",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#e3a5f2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,5,11,0,0,11",
    transform: "translate(2 7)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColumns, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/columns.187a2452.svg";
export { ForwardRef as ReactComponent };